import React from 'react';
import { useTheme } from '@mui/material';

export const Support = (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryColor },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} fill="none" {...props}>
            <g clipPath="url(#a)">
                <path
                    fill={primaryColor}
                    d="M20.087 35.251H35.25a3.247 3.247 0 0 0 3.25-3.25v-19.5a3.247 3.247 0 0 0-3.25-3.25H6a3.247 3.247 0 0 0-3.25 3.25V32A3.247 3.247 0 0 0 6 35.251h3.25a3.247 3.247 0 0 1 3.25 3.25v1.626l5.637-4.226a3.216 3.216 0 0 1 1.95-.65Zm15.163 3.25H20.087l-8.237 6.176a1.64 1.64 0 0 1-1.706.152 1.6 1.6 0 0 1-.894-1.452V38.5H6A6.506 6.506 0 0 1-.5 32V12.5C-.5 8.914 2.415 6 6 6h29.25c3.585 0 6.5 2.915 6.5 6.5v19.501c0 3.585-2.915 6.5-6.5 6.5ZM32 51.502a6.506 6.506 0 0 1-6.5-6.5v-3.25h3.25v3.25a3.247 3.247 0 0 0 3.25 3.25h11.913c.701 0 1.392.223 1.95.65l5.637 4.225v-1.625a3.247 3.247 0 0 1 3.25-3.25H58a3.247 3.247 0 0 0 3.25-3.25V25.5A3.247 3.247 0 0 0 58 22.25H45V19h13c3.585 0 6.5 2.915 6.5 6.5V45a6.506 6.506 0 0 1-6.5 6.501h-3.25v4.875c0 .62-.345 1.178-.894 1.453a1.644 1.644 0 0 1-1.706-.153l-8.237-6.175H32ZM18.218 13.14a3.912 3.912 0 0 0-3.697 2.61l-.03.092a1.618 1.618 0 0 0 .985 2.072 1.626 1.626 0 0 0 2.072-.985l.03-.092a.668.668 0 0 1 .64-.447h4.195a1.19 1.19 0 0 1 .589 2.225l-3.19 1.828A1.617 1.617 0 0 0 19 21.855v.965a1.63 1.63 0 0 0 1.625 1.625 1.63 1.63 0 0 0 1.625-1.625v-.031l2.377-1.35a4.436 4.436 0 0 0-2.204-8.288h-4.195l-.01-.01Zm2.407 18.323a2.305 2.305 0 1 0 0-4.601 2.307 2.307 0 0 0-.928 4.472c.297.106.613.15.928.129Z"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="white" d="M0 0h64v64H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Support;
